type EventsNavLink = {
    name: string;
    slug: string;
};

export const EVENTS_NAV_TITLE = 'События';

export const EVENTS_NAV_ITEMS: EventsNavLink[] = [
    { name: 'Премия Территория технологий', slug: '/events/premiya-tec/' },
    { name: 'Технологические дни', slug: '/events/technological/' },
    { name: 'HR-Саммит и Премия', slug: '/events/summit/' },
    { name: 'TNF LIVE', slug: '/events/tnf-live/' },
];

export const trackEventsNavClick = () => window._txq?.push(['track', 'sobitiya']);

export const EVENTS_NAV = {
    name: EVENTS_NAV_TITLE,
    links: EVENTS_NAV_ITEMS,
    onClick: trackEventsNavClick,
};
